import { render, staticRenderFns } from "./aOwnerDetailAccount.vue?vue&type=template&id=4f5e328d"
import script from "./aOwnerDetailAccount.vue?vue&type=script&lang=js"
export * from "./aOwnerDetailAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports